import React from 'react';
import { Box, Card, CardContent, Grid, Skeleton } from '@mui/material';

interface FormSkeletonProps {
  fields?: number;
  hasTitle?: boolean;
  hasTabs?: boolean;
}

const FormSkeleton: React.FC<FormSkeletonProps> = ({ fields = 6, hasTitle = true, hasTabs = false }) => {
  return (
    <Box>
      {/* Breadcrumb skeleton */}
      <Box sx={{ mb: 1 }}>
        <Skeleton variant="text" width={180} height={20} />
      </Box>

      {/* Title skeleton */}
      {hasTitle && (
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="text" width={280} height={40} />
        </Box>
      )}

      {/* Tabs skeleton */}
      {hasTabs && (
        <Box sx={{ display: 'flex', gap: 3, mb: 3, borderBottom: 1, borderColor: 'divider', pb: 1 }}>
          <Skeleton variant="text" width={70} height={32} />
          <Skeleton variant="text" width={80} height={32} />
          <Skeleton variant="text" width={100} height={32} />
          <Skeleton variant="text" width={60} height={32} />
        </Box>
      )}

      <Card>
        <CardContent>
          <Grid container spacing={3}>
            {Array.from({ length: fields }).map((_, i) => (
              <Grid item xs={12} sm={i < 2 ? 6 : 12} key={i}>
                <Skeleton variant="text" width={100} height={18} sx={{ mb: 0.5 }} />
                <Skeleton variant="rounded" width="100%" height={56} />
              </Grid>
            ))}

            {/* Action buttons */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Skeleton variant="rounded" width={100} height={36} />
                <Skeleton variant="rounded" width={120} height={36} />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FormSkeleton;
